<template>
  <el-dialog
      :visible.sync="visible"
      :title="title"
      :width="width"
      :before-close="handleClose"
      class="complaint-progress-modal"
      :close-on-click-modal="false"
  >
    <!-- 头部信息卡片 -->
    <div style="padding: 10px;">
      <div style="display: flex;align-items: baseline;margin-top: 20px;">
        <div style="margin-right: 10px;font-size: 14px;">驳回原因：</div>
        <el-input placeholder="请输入内容" v-model="input1" style="flex:1;background: #013230;border-radius: 5px;" type="textarea"
          :autosize="{ minRows: 4, maxRows: 8}">
        </el-input>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="fundaudit">立即发送</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { fundaudit } from '@/api/estate'
export default {
  name: 'InterventionModal',
  props: {
    // 控制弹窗显示/隐藏
    visible: {
      type: Boolean,
      default: false
    },
    // 弹窗标题
    title: {
      type: String,
      default: '驳回'
    },
    // 弹窗宽度
    width: {
      type: String,
      default: '60%'
    },
    // 事件信息
    eventInfo: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      title1: '',
      input1: '',
      time: '',
    }
  },
  computed: {

  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    // 关闭弹窗时触发
    fundaudit() {
      fundaudit({
        id: this.eventInfo.id,
        rejectReason: this.input1,
        applicationStatus:2
      }).then(res => {
        this.input1=''
        this.$message.success('操作成功')
        this.$emit('update:visible', false)
        this.$emit('close')
      })
      
    },

  }
}
</script>

<style scoped>
.complaint-progress-modal {
  --primary-color: #409EFF;
  --success-color: #67C23A;
  --text-primary: #FFFFFF;
  --text-secondary: rgba(255, 255, 255);
  --bg-card: rgba(30, 58, 138);
  --border-color: rgba(4, 13, 15);
}

.event-card {
  background-color: transparent;
  border: 1px solid #2a4361;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 50px;
  font-size: 16px;
}

.event-card::v-deep .el-card__header {
  border-bottom: none !important;
  padding: 0 0 0 0;
  background: linear-gradient(to right, rgba(15, 61, 58, 0.5) 0%, rgba(15, 61, 58, 0) 100%);
}

.event-card::v-deep .el-card__body {
  padding: 0;
}

.event-status {
  display: flex;
  align-items: center;
  padding: 8px 15px;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.5);

}

.event-status i {
  margin-right: 5px;
}

/*.processing .event-status {*/
/*  background-color: #13c2c2;*/
/*  color: #fff;*/
/*}*/

.community-name {
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.event-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 12px;
  color: #86909c;
}

.event-content {
  padding: 15px;
}

.status-tag {
  margin-bottom: 16px;
}

.event-title {
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.type-label {
  color: var(--primary-color);
}

.separator {
  margin: 0 8px;
  color: var(--text-secondary);
}

.community, .property {
  color: var(--text-secondary);
}

.event-desc {
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 16px;
  padding-left: 2px;
}

.event-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
}

.meta-item {
  color: var(--text-secondary);
  font-size: 12px;
  display: flex;
  align-items: center;
}

.meta-label {
  color: rgba(255, 255, 255);
  margin-right: 4px;
}

.progress-timeline {
  margin-bottom: 20px;
}

/deep/ .el-timeline-item__timestamp {
  color: var(--text-secondary);
  font-size: 12px;
}

.timeline-content {
  margin-top: 4px;
}

.content-text {
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0;
}

.intervention-section {
  border-left: 2px solid var(--primary-color);
  padding-left: 16px;
  margin-bottom: 10px;
}

.intervention-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.intervention-time {
  color: var(--primary-color);
  font-size: 12px;
  margin-right: 10px;
}

.intervention-tag {
  color: var(--primary-color);
  font-size: 12px;
  background-color: rgba(64, 158, 255, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
}

.intervention-details {
  margin-left: 2px;
}

.detail-item {
  color: var(--text-secondary);
  font-size: 12px;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
}

.detail-label {
  color: rgba(255, 255, 255);
  margin-right: 4px;
  min-width: 50px;
}

.dialog-footer {
  display: flex;
  padding: 10px 20px;
  background-color: #0A2023;
  justify-content: end;
}

::v-deep .el-input__inner::placeholder {
  color: #fff; /* 输入文字颜色 */
}

::v-deep .el-textarea__inner::placeholder {
  color: #fff; /* 输入文字颜色 */
}

/deep/ .el-dialog {
  background-color: rgba(0,0,0,0.6);
  border: 1px solid rgba(255, 255, 255,0.8);
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid var(--border-color);
  background-color: #013230;
  padding: 0;
}

/deep/ .el-dialog__title {
  color: #4DF1E3;
  width: 200px;
  height: 48px;
  line-height: 48px;
  padding-left: 20px;
  font-size: 18px;
  background-color: #015658;
  clip-path: polygon(0 0, 70% 0%, 100% 100%, 0 100%);
  flex-shrink: 0; /* 防止被压缩 */
}

/deep/ .el-dialog__close {
  color:#4DF1E3;
}

/deep/ .el-dialog__body {
  color: var(--text-secondary);
  background-color: #0A2023;
}

/deep/ .el-dialog__footer {
  padding: 0 !important;
}

/deep/ .el-button {
  background: linear-gradient( 360deg, #00B6B3 0%, rgba(0,121,117,0.57) 33%, rgba(0,121,117,0) 72%, #008785 100%);
  color: #B1F7FA;
  border: none;
  border-radius: 30px;
  width: 80px;
}

/deep/ .el-button:hover {
  background-color: rgba(64, 158, 255, 0.3);
  color: var(--primary-color);
  border-color: var(--primary-color);
}
</style>
